import { useState } from "react";
import { PERIOD_LABELS } from "../lib/format";

const OPTIONS = ["today", "yesterday", "this_month", "previous_month", "custom"];

export default function PeriodFilter({ period, setPeriod, custom, setCustom, showMonthly = true }) {
  const [localStart, setLocalStart] = useState(custom?.start || "");
  const [localEnd, setLocalEnd] = useState(custom?.end || "");

  const options = showMonthly ? OPTIONS : OPTIONS.filter((o) => !["this_month", "previous_month"].includes(o));

  const apply = () => {
    if (localStart && localEnd) setCustom({ start: localStart, end: localEnd });
  };

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {options.map((o) => (
          <button
            key={o}
            onClick={() => setPeriod(o)}
            data-testid={`period-${o}`}
            className={`rounded-full border px-4 py-1.5 text-sm font-medium transition-colors ${
              period === o
                ? "border-blue-700 bg-blue-700 text-white"
                : "border-slate-300 bg-white text-slate-700 hover:bg-slate-50"
            }`}
          >
            {PERIOD_LABELS[o]}
          </button>
        ))}
      </div>
      {period === "custom" && (
        <div className="flex flex-wrap items-end gap-3 rounded-lg border border-slate-200 bg-white p-4">
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-500">Start date</label>
            <input
              type="date"
              value={localStart}
              onChange={(e) => setLocalStart(e.target.value)}
              data-testid="custom-start-date"
              className="rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-blue-700 focus:ring-2 focus:ring-blue-700"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-500">End date</label>
            <input
              type="date"
              value={localEnd}
              onChange={(e) => setLocalEnd(e.target.value)}
              data-testid="custom-end-date"
              className="rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-blue-700 focus:ring-2 focus:ring-blue-700"
            />
          </div>
          <button
            onClick={apply}
            data-testid="apply-custom-range"
            className="rounded-md bg-blue-700 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-800"
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
}
